<app-template>
    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">
        <div class="principal-support">
            <div class="container max-width">
                <div class="info">
                    <br>
                    <br>
                    <h1><p class="principal">
                        Você tem alguma dúvida ou <span>precisa de ajuda?</span>
                    </p></h1>
                    <div class="description">
                        <h2>Fale com um especialista:</h2>
                    </div>
                    <p class="contact bold" style="color: #a80a34">
                        WhatsApp Vendas: <br><a style="color: #a80a34" href="https://api.whatsapp.com/send/?phone=5511915505480&text=Ol%C3%A1,%20tenho%20interesse%20em%20trabalhar%20com%20FAD%20-%20Assinatura%20Aut%C3%B3grafa%20Digital&utm_campaign=23.WhatsApp&utm_source=ecommerce_fad_pt&utm_medium=boton_pt" target="_blank">+55 119 1550 5480</a><br>
                    </p>
                    <br>
                    <p class="contact" style="font-size: 20px">
                        WhatsApp Suporte:<br><a href="https://api.whatsapp.com/send/?phone=5511997908122&utm_campaign=23.WhatsApp&utm_source=ecommerce_fad_pt&utm_medium=soporte" target="_blank">+55 11 99790-8122</a>
                    </p>
                    <p class="text" style="padding: 10px 0;">* FAD® não armazena nenhum documento assinado, o usuário é responsável por armazenar os arquivos gerados no processo de assinatura.</p>
                </div>
                <div class="image">
                    <img src="assets/images/3_opciones.png" alt="Suscripciones">
                </div>
            </div>
        </div>

        <div class="form-container">
            <div class="side-panel">
                <div class="absolute">
                    <p>Envie-nos seus dados para <span>entendermos sua necessidade:</span></p>
                </div>
            </div>
            <div class="form" id="form-support">
                <p class="title-1">
                    Você também pode <span>entrar em contato conosco</span> através do seguinte <span>formulário:</span>
                </p>
                <form [id]="idForm"></form>
            </div>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" id="main" #main *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
            </div>
            <div class="content-res">
                <h1>Você tem alguma dúvida ou <span>precisa de ajuda?</span>?</h1>
                <h2><p class="text">
                    Fale com um especialista:
                    <br>
                    <br><strong style="color:#a80a34;">WhatsApp Vendas: <br><a style="color:#a80a34;"href="https://api.whatsapp.com/send/?phone=5511915505480&text=Ol%C3%A1,%20tenho%20interesse%20em%20trabalhar%20com%20FAD%20-%20Assinatura%20Aut%C3%B3grafa%20Digital&utm_campaign=23.WhatsApp&utm_source=ecommerce_fad_pt&utm_medium=boton_pt"  target="_blank">+55 119 1550 5480</a></strong>
                    <br><br>
                    WhatsApp Suporte: <br><a href="https://api.whatsapp.com/send/?phone=5511997908122&utm_campaign=23.WhatsApp&utm_source=ecommerce_fad_pt&utm_medium=soporte" target="_blank">+55 11 99790-8122</a>
                </p></h2>
                <p class="text" style="padding: 10px 0;text-align: left">* FAD® não armazena nenhum documento assinado, o usuário é responsável por armazenar os arquivos gerados no processo de assinatura.</p>
            </div>

            <div class="box-light-fondo">
                <div class="wrapper">
                    <div class="content-res" style="padding-bottom: 0px;">
                        <p class="light" style="margin-bottom: 0px;">
                            <span>Envie-nos seus dados para</span> entendermos sua necessidade:</p>
                    </div>
                    <div class="form" id="form-support-movil">

                    </div>
                </div>
            </div>
        </div>
    </div>

</app-template>
